import { Loader } from './Loader';
import { flatten } from 'array-flatten';
/**
 * A {@link Loader} that loads {@link Loader}
 * @extends Loader
 * @category loader
 * @author Geoffrey Mayeux
 */
class LoaderLoader extends Loader{
	constructor(){
		super();
	}

	accepts(item){
		return item instanceof Loader;
	}

	async loadItem(item){
		const itemProgress = progress => {
			this.progresses.set(item, progress);
			this.triggerProgress();
		};

		item.on('progress', itemProgress);
		await item.load();
		item.off('progress', itemProgress);
	}

}

export default LoaderLoader;
export { LoaderLoader };